import type { BaseQueryFn } from '@reduxjs/toolkit/query';
import type { AxiosRequestConfig, AxiosError } from 'axios';
import AxiosFlexeServeInstance from './AxiosFlexeServe';
import toSerializableError from './toSerializableError';

const axiosBaseQuery =
  (options?: { baseUrl?: string }): BaseQueryFn<AxiosRequestConfig> =>
  async ({ url, method = 'get', ...otherArgs }) => {
    const baseUrl = options?.baseUrl ?? '';
    try {
      const result = await AxiosFlexeServeInstance({
        url: baseUrl + url,
        method,
        ...otherArgs,
      });
      return { data: result?.data };
    } catch (axiosError) {
      const err = axiosError as AxiosError<any>;
      const serializedError = toSerializableError(axiosError) as {
        message?: string;
      };
      const message = serializedError.message ?? 'Unknown error';
      const error = {
        status: err.response?.status,
        data: err.response?.data?.error || err.response?.data || message,
        message,
      };
      return {
        error,
      };
    }
  };

export default axiosBaseQuery;
